import { render, staticRenderFns } from "./jifen.vue?vue&type=template&id=9c0e568a&scoped=true&"
import script from "./jifen.vue?vue&type=script&lang=js&"
export * from "./jifen.vue?vue&type=script&lang=js&"
import style0 from "./jifen.vue?vue&type=style&index=0&id=9c0e568a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0e568a",
  null
  
)

export default component.exports